var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.853 17.97H6.73297C2.75297 17.97 1.54297 16.76 1.54297 12.78V6.44C1.54297 2.46 2.75297 1.25 6.73297 1.25H17.843C21.823 1.25 23.033 2.46 23.033 6.44V12.77C23.043 16.76 21.833 17.97 17.853 17.97ZM6.73297 2.75C3.59297 2.75 3.04297 3.3 3.04297 6.44V12.77C3.04297 15.91 3.59297 16.46 6.73297 16.46H17.843C20.983 16.46 21.533 15.91 21.533 12.77V6.44C21.533 3.3 20.983 2.75 17.843 2.75H6.73297Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.293 22.75C11.883 22.75 11.543 22.41 11.543 22V17.22C11.543 16.81 11.883 16.47 12.293 16.47C12.703 16.47 13.043 16.81 13.043 17.22V22C13.043 22.41 12.703 22.75 12.293 22.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.293 13.75H2.29297C1.88297 13.75 1.54297 13.41 1.54297 13C1.54297 12.59 1.88297 12.25 2.29297 12.25H22.293C22.703 12.25 23.043 12.59 23.043 13C23.043 13.41 22.703 13.75 22.293 13.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.793 22.75H7.79297C7.38297 22.75 7.04297 22.41 7.04297 22C7.04297 21.59 7.38297 21.25 7.79297 21.25H16.793C17.203 21.25 17.543 21.59 17.543 22C17.543 22.41 17.203 22.75 16.793 22.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.64f32fa15fbfadaba5a078dcadfc45de.svg";
export { ForwardRef as ReactComponent };